import styled from 'styled-components';

export const Wrapper = styled.div``;

export const TopHeading = styled.div`
  background: linear-gradient(
    119.08deg,
    #5ca7ed 0%,
    #5e60ef 47.92%,
    #b375f8 100%
  );
  border-radius: 6px 6px 0px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 25px;
  font-family: font-semibold;
  font-weight: 600;
  font-size: 22px;
  color: #ffffff;
`;

export const FormWrapper = styled.div`
  padding: 25px 30px;
  border: 1px solid #c2c2c2;
  border-top: none;
  border-radius: 0 0 6px 6px;

  h3.formHeading {
    margin-bottom: 30px;
    font-weight: 600;
    font-family: font-semibold;
    font-size: 18px;
    color: #000000;
  }

  @media (max-width: 576px) {
    padding: 20px;

    h3.formHeading {
      margin-bottom: 20px;
    }
  }
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 20px;

  @media (max-width: 576px) {
    margin-bottom: 0;
  }
`;

export const InputWrapper = styled.div`
  width: 48%;
  margin-bottom: 0;

  @media (max-width: 576px) {
    width: 100%;
    margin-bottom: 10px;
  }

  input {
    display: block;
    width: 100%;
    padding: 23px 20px;
    border: 1px solid #c2c2c2;
    border-radius: 6px;
    outline: none;
    background: none;
    font-weight: 500;
    font-size: 13px;
    font-family: font-medium;
    color: #363636;

    &::placeholder {
      font-weight: 500;
      font-size: 13px;
      font-family: font-medium;
      color: #656363;
    }

    &:-ms-input-placeholder {
      font-weight: 500;
      font-size: 13px;
      font-family: font-medium;
      color: #656363;
    }

    &::-ms-input-placeholder {
      font-weight: 500;
      font-size: 13px;
      font-family: font-medium;
      color: #656363;
    }
  }
`;

export const TextArea = styled.textarea`
  display: block;
  width: 100%;
  resize: none;
  height: 130px;
  padding: 23px 20px;
  border: 1px solid #c2c2c2;
  border-radius: 6px;
  outline: none;
  background: none;
  font-weight: 500;
  font-size: 13px;
  font-family: font-medium;
  color: #363636;
  margin-bottom: 35px;

  &::placeholder {
    font-weight: 500;
    font-size: 13px;
    font-family: font-medium;
    color: #656363;
  }

  &:-ms-input-placeholder {
    font-weight: 500;
    font-size: 13px;
    font-family: font-medium;
    color: #656363;
  }

  &::-ms-input-placeholder {
    font-weight: 500;
    font-size: 13px;
    font-family: font-medium;
    color: #656363;
  }
`;

export const RadioWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

export const SingleRadioOption = styled.div<any>`
  display: flex;
  align-items: center;
  width: unset;
  cursor: pointer;
  margin-right: 15px;

  &:last-child {
    margin-right: 0;
  }

  .radio {
    width: 14px;
    height: 14px;
    border-radius: 100%;
    border: 2px solid #d9d9d9;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 7px;

    .circle {
      width: 0;
      height: 0;
      border-radius: 100%;

      background: #5da5ed;
      transition: 0.3s;
    }

    &.selected {
      .circle {
        width: 8px;
        height: 8px;
      }
    }
  }

  span.label {
    font-weight: 500;
    font-family: font-medium;
    font-size: 13px;
    color: #656363;
  }
`;

export const Error = styled.p`
  font-weight: 600;
  font-family: font-semibold;
  font-size: 16px;
  text-align: center;
  color: #ff2233;
  margin-bottom: 20px;
`;

export const Success = styled.p`
  font-weight: 600;
  font-family: font-semibold;
  font-size: 16px;
  text-align: center;
  color: #5da6ed;
  margin-bottom: 20px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const SubmitButton = styled.div`
  cursor: pointer;
  border-radius: 6px;
  text-decoration: none;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 8;
  background: linear-gradient(
    96.91deg,
    #5ca6ed 0%,
    #5f60ef 48.46%,
    #b174f8 100%
  );
  height: 70px;
  width: 270px;
  letter-spacing: 3px;

  &:after {
    border-radius: 6px;
    position: absolute;
    content: '';
    z-index: 9;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: linear-gradient(
      96.91deg,
      #5ca6ed 0%,
      #5f60ef 48.46%,
      #b174f8 100%
    );
    transform: rotate(180deg);
    opacity: 0;
    transition: 0.3s;
  }

  .text {
    font-family: font-semibold;
    font-size: 18px;
    font-weight: 600;
    color: #ffffff;
    transition: 0.3s;
    letter-spacing: 3px;
    position: relative;
    z-index: 10;
  }

  &:hover {
    &:after {
      opacity: 1;
    }
  }
`;
